import { useTranslation } from "react-i18next";
import { api } from "@/helper/api";
import { useConfirmationModal } from "@/context/confirmationModalContext";

interface UseTwoFactorToggleOptions {
  notify: (message: string, variant: "success") => void;
  onError: (error: any) => void;
  onSaved: () => void;
}

export function useTwoFactorToggle(options: UseTwoFactorToggleOptions) {
  const { t } = useTranslation();
  const { showConfirmationModalAsync } = useConfirmationModal();

  return async (event: any, row: any) => {
    const newChecked = event.target.checked;
    const userId = row.id;
    const name = row.first_name + " " + row.last_name;

    const confirmationMessage = event.target.checked
      ? t("2fa_activation_confirmation_admin", { name: name })
      : t("2fa_deactivation_confirmation_admin", { name: name });

    const isConfirmed = await showConfirmationModalAsync(confirmationMessage);

    if (!isConfirmed) return;

    api.genericApiRequest({
      method: "put",
      entity: "user",
      entityId: userId,
      submitData: { requires_two_factor: newChecked },
      successHandler: () => {
        options.notify(t("successfully_saved"), "success");
        options.onSaved();
      },
      failHandler: (error: any) => {
        options.onError(error);
      },
    });
  };
}
